import React from "react";
import { Col, Row } from "design-react-kit";
import { ValidatedForm, FormEnabler, MFile, MLabel } from "components/forms";

class TirocinioDirettoStep0 extends ValidatedForm {
  emptyFields = {};

  state = {
    ...this.emptyFields,
    defaultValues: { ...this.emptyFields },
  };

  FIELDS_GROUP = [
    [
      {
        field: "attestatoSicurezzaLabel",
        label: "Attestato sulla sicurezza",
        component: MLabel,
        className: "col-md-6 pt-3 pb-0 mb-0",
      },
      {
        id: "attestatoSicurezzaFile",
        field: "document",
        label: "Attestato sulla sicurezza",
        component: MFile,
        config: {
          endPoint: "lesson-activity-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "attestatoSicurezza",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
  ];

  ERROR_MESSAGES = {};
  validation = {};

  componentDidMount() {
    const { defaultValues } = this.props;

    if (defaultValues) {
      this.setState({ ...defaultValues, defaultValues });
    }
  }

  onSubmit = (e) => {
    if (e) e.preventDefault();

    if (!this.checkValidation()) return;
    this.props.onSubmit();
  };

  render() {
    const { formActive, onToggleEdit } = this.props;
    const { defaultValues } = this.state;

    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, formActive);

    return (
      <Row>
        <Col className="col-12 mt-3">
          <form className="mt-3">{code}</form>
          <FormEnabler isFormActive={formActive} onSubmit={this.onSubmit} onCancel={onToggleEdit} />
        </Col>
      </Row>
    );
  }
}

export default TirocinioDirettoStep0;
